var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.1006C17 16.3062 15.2056 18.1006 13 18.1006C10.7944 18.1006 9 16.3062 9 14.1006C9 11.895 10.7944 10.1006 13 10.1006C15.2056 10.1006 17 11.895 17 14.1006Z",
    fill: "url(#paint0_linear_2464_4300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0227 4.03067L15.5551 5.46127L15.9015 7.48127C16.0066 8.09397 15.3635 8.56117 14.8133 8.27192L12.9992 7.31812L11.1851 8.27187C10.6349 8.56112 9.99181 8.09392 10.0969 7.48122L10.4434 5.46122L8.97571 4.03067C8.53056 3.59677 8.77621 2.84082 9.39136 2.75142L11.4196 2.45667L12.3267 0.618771C12.6018 0.0613211 13.3967 0.0613211 13.6718 0.618771L14.5788 2.45667L16.6071 2.75142C17.2222 2.84082 17.4679 3.59677 17.0227 4.03067ZM25.1563 5.85142L23.128 5.55667L22.221 3.71877C21.9459 3.16132 21.151 3.16132 20.8759 3.71877L19.9688 5.55667L17.9406 5.85142C17.3254 5.94082 17.0798 6.69677 17.5249 7.13067L18.9926 8.56127L18.6461 10.5813C18.541 11.194 19.1841 11.6612 19.7343 11.3719L21.5484 10.4182L23.3625 11.3719C23.9127 11.6612 24.5558 11.194 24.4507 10.5813L24.1043 8.56127L25.5719 7.13067C26.017 6.69677 25.7714 5.94082 25.1563 5.85142ZM6.02966 5.55662L5.12256 3.71877C4.84746 3.16132 4.05256 3.16132 3.77746 3.71877L2.87041 5.55667L0.842162 5.85142C0.227012 5.94082 -0.018588 6.69677 0.426512 7.13067L1.89416 8.56127L1.54771 10.5813C1.44261 11.194 2.08571 11.6612 2.63591 11.3719L4.45001 10.4182L6.26411 11.3719C6.81431 11.6612 7.45741 11.194 7.35231 10.5813L7.00586 8.56127L8.47351 7.13067C8.91866 6.69677 8.67301 5.94082 8.05786 5.85142L6.02966 5.55662ZM15.2084 17.4331C14.575 17.8544 13.8154 18.1007 12.9992 18.1007C12.183 18.1007 11.4235 17.8544 10.79 17.4331C7.72941 18.3783 5.49921 21.2338 5.49921 24.6007V25.0507C5.49921 25.4649 5.83501 25.8007 6.24921 25.8007H19.7492C20.1634 25.8007 20.4992 25.4649 20.4992 25.0507V24.6007C20.4992 21.2338 18.269 18.3783 15.2084 17.4331Z",
    fill: "url(#paint1_linear_2464_4300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2464_4300",
    x1: 13,
    y1: 18.1006,
    x2: 13,
    y2: 10.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#F0FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2464_4300",
    x1: 12.9992,
    y1: 25.8007,
    x2: 12.9992,
    y2: 0.200671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCustomer);
export default __webpack_public_path__ + "static/media/total-customer.27edb900fa6c4ab11056b1c7d9488365.svg";
export { ForwardRef as ReactComponent };